"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../../constants");

var util_1 = require("../util"); // tslint:disable:object-literal-sort-keys
// do not sort these keys, their order
// determines the shape of the request
// sent to the pin pad
// device status message should always
// have subtype = 1


var DEVICE_STATUS_SUBTYPE = 1;
/**
 * Device Status can be used for a health check to verify
 * that the client can connect to mcm. It can also be used
 * to request that mcm perform certain actions, including
 * administrative actions like preventing new transactions
 * and cancelling transactions in progress but not all
 * actions are supported for all pin pads
 */

var DeviceStatusSchema = {
  transactionType: {
    length: 2,
    type: constants_1.FieldType.fixed,
    value: constants_1.TransactionType.DeviceStatus
  },
  transactionSubtype: {
    length: 1,
    type: constants_1.FieldType.fixed,
    value: DEVICE_STATUS_SUBTYPE
  },

  /**
   * Pin Pad Status request type
   * @see DeviceStatusRequestIndicator
   */
  getPinPadStatus: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * Get Host Status flag
   * @see HostStatusRequestIndicator
   */
  getHostStatus: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * Stop Processing flag
   * @see StopProcessingRequestIndicator
   */
  stopProcessingFlag: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * Return version flag
   * @see ReturnVersionRequestIndicator
   */
  returnVersionFlag: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * Last Transaction Status flag
   * @see LastTransactionStatusRequestIndicator
   */
  lastTransactionFlag: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * Pin Pad Action Flag
   * @see DeviceTypeActionIndicator
   */
  deviceTypeActionFlag: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * Pin Pad Action 1 flag
   * Only available for "Device Type 2" (E355)
   * @see PinPadAction1Indicator
   */
  pinPadAction1Flag: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * Pin Pad Action 2 flag
   * Only available when pinPadAction1Flag
   * is set to PinPadActionIndicator.ChangeConfiguration
   * @see PinPadAction2Indicator
   */
  pinPadAction2Flag: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * Pin Pad Action3 flag
   * Used in conjunction with Action2 to enable and
   * disable barcode scanner configurations
   *
   * @see PinPadAction3IndicatorContinuousMode
   * @see PinPadAction3IndicatorAutoBeepMode
   * @see PinPadAction3IndicatorSymbologyParameters
   */
  pinPadAction3Flag: {
    length: 2,
    type: constants_1.FieldType.numeric
  },

  /**
   * Pin Pad Action4 flag
   * Used in conjunction with
   * PinPadAction3IndicatorSymbologyParameters to
   * enable/disable the scanning of the given
   * barcode symbology. supporting more of
   * symbologies may impact scanner performance
   * @see PinPadAction4Indicator
   */
  pinPadAction4Flag: {
    length: 1,
    type: constants_1.FieldType.numeric
  },

  /**
   * reserved field
   */
  empty0: {
    length: 55,
    type: constants_1.FieldType.reserved
  },

  /**
   * terminal ID
   */
  terminalId: {
    length: 12,
    type: constants_1.FieldType.numeric
  }
};

exports.deviceStatus = function (_a) {
  var _b = _a.deviceTypeActionFlag,
      deviceTypeActionFlag = _b === void 0 ? constants_1.DeviceTypeActionIndicator.NoDeviceSelected : _b,
      getHostStatus = _a.getHostStatus,
      getPinPadStatus = _a.getPinPadStatus,
      _c = _a.lastTransactionFlag,
      lastTransactionFlag = _c === void 0 ? constants_1.LastTransactionStatusRequestIndicator.NoAction : _c,
      _d = _a.pinPadAction1Flag,
      pinPadAction1Flag = _d === void 0 ? constants_1.PinPadAction1Indicator.NoAction : _d,
      _e = _a.pinPadAction2Flag,
      pinPadAction2Flag = _e === void 0 ? constants_1.PinPadAction2Indicator.NoAction : _e,
      _f = _a.pinPadAction3Flag,
      pinPadAction3Flag = _f === void 0 ? constants_1.PinPadAction3IndicatorAutoBeepMode.Disable : _f,
      _g = _a.pinPadAction4Flag,
      pinPadAction4Flag = _g === void 0 ? constants_1.PinPadAction4Indicator.Disable : _g,
      _h = _a.returnVersionFlag,
      returnVersionFlag = _h === void 0 ? constants_1.ReturnVersionRequestIndicator.NoAction : _h,
      _j = _a.stopProcessingFlag,
      stopProcessingFlag = _j === void 0 ? constants_1.StopProcessingRequestIndicator.NoAction : _j,
      terminalId = _a.terminalId;
  return util_1.prepare({
    deviceTypeActionFlag: deviceTypeActionFlag,
    getHostStatus: getHostStatus,
    getPinPadStatus: getPinPadStatus,
    lastTransactionFlag: lastTransactionFlag,
    pinPadAction1Flag: pinPadAction1Flag,
    pinPadAction2Flag: pinPadAction2Flag,
    pinPadAction3Flag: pinPadAction3Flag,
    pinPadAction4Flag: pinPadAction4Flag,
    returnVersionFlag: returnVersionFlag,
    stopProcessingFlag: stopProcessingFlag,
    terminalId: terminalId
  }, DeviceStatusSchema);
};

exports.parseResponse = function (data) {
  var responseString = data.toString(constants_1.Encoding.ascii);

  var _a = responseString.split(constants_1.ResponseDelimiter.CRLF),
      rcpLine = _a[1],
      responseLines = _a.slice(2);

  var _b = rcpLine.split(constants_1.ResponseDelimiter.FS),
      trmLine = _b[2];

  var _c = trmLine.split(constants_1.ResponseDelimiter.Colon),
      terminalId = _c[1];

  var formattedResponse = responseLines.slice(0, responseLines.length - 2).reduce(function (acc, line) {
    var _a;

    var _b = line.split(constants_1.ResponseDelimiter.Colon),
        key = _b[0],
        value = _b[1];

    var intValue = parseInt(value, 10);
    var readableKey = util_1.mapKeyToReadableKey(key);
    return __assign(__assign({}, acc), (_a = {}, _a[readableKey] = !isNaN(intValue) ? intValue : value, _a));
  }, {});
  return Object.assign({}, {
    terminalId: terminalId
  }, formattedResponse, {
    rawResponse: responseString
  });
};